/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppVersionDTO } from '../models/AppVersionDTO';
import type { TranslationApp } from '../models/TranslationApp';
import type { TranslationsDto } from '../models/TranslationsDto';
import type { UploadedFileDto } from '../models/UploadedFileDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OtherService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get translations batch
     * @param apps
     * @returns TranslationsDto
     * @throws ApiError
     */
    public getBatch(
        apps: Array<TranslationApp>,
    ): CancelablePromise<TranslationsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/translations/batch',
            query: {
                'apps': apps,
            },
        });
    }

    /**
     * @returns AppVersionDTO
     * @throws ApiError
     */
    public getAppVersions(): CancelablePromise<AppVersionDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/project-setting/app-version',
        });
    }

    /**
     * Create cloud file. Accepts form-data with the file. Returns a link to the file
     * @param formData
     * @returns UploadedFileDto
     * @throws ApiError
     */
    public upload(
        formData: {
            /**
             * File to upload
             */
            file: Blob;
        },
    ): CancelablePromise<UploadedFileDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/cloud-file',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * Create cloud file by doctor. Accepts form-data with the file. Returns a link to the file
     * @param formData
     * @returns UploadedFileDto
     * @throws ApiError
     */
    public uploadByMedstaff(
        formData: {
            /**
             * File to upload
             */
            file: Blob;
        },
    ): CancelablePromise<UploadedFileDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/cloud-file/medstaff',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

}
